import React, { memo } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Link from 'next/link';

import { capitalizeFLetter } from '@/utils/helpers';

function Index({ ads }: any) {
  return (
    <>
      <div className="item-card toppremium-post-listing">
        {ads.ads_images.length ? (
          <div className="item-img-sld">
            <div className="owl-carousel">
              <Carousel
                showArrows={true}
                infiniteLoop={true}
                swipeable={true}
                statusFormatter={() => `247Torax`}
                dynamicHeight={true}
                showThumbs={false}
                autoPlay={true}
              >
                {ads.ads_images.map((images: any, index: number) => (
                  <div key={index} className="item">
                    <div className="ads-img">
                      <img
                        loading="lazy"
                        src={process.env.REACT_APP_API_UPLOADS + images.image_url}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = '/assets/img/no-found.webp';
                        }}
                        alt={capitalizeFLetter(ads.city) + ads.title}
                      />
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        ) : null}

        <div className="ads-cont">
          <div className="ads-left-cont">
            <Link href={`/ads-details/${ads.adsNo}`}>{`${ads.extra_title} ${ads.title}`}</Link>
            <div className="ads_para" dangerouslySetInnerHTML={{ __html: ads?.description ?? '' }}></div>
            <div className="tagcard">
              <strong>Age :- {ads.age} YEARS</strong>
              <strong> {ads.category.charAt(0).toUpperCase() + ads.category.slice(1)} </strong>
              <strong className="normal-f"> {capitalizeFLetter(ads.state)} </strong>
              <strong className="normal-f"> {capitalizeFLetter(ads.city)} </strong>
              {ads?.area ? <strong className="normal-f"> {capitalizeFLetter(ads?.area)} </strong> : ''}
            </div>
          </div>
          <div className="item-card-contact">
            <div className="view-all-wrap">
              <Link href={`/ads-details/${ads.adsNo}`} className="btncontact">
                View All
              </Link>
            </div>
            {ads.is_whatsapp && (
              <Link
                href={`https://api.whatsapp.com/send/?phone=${ads.contact_no}&amp;text=${ads.contact_no},and I'd like to meet you.`}
                className="btncontact"
              >
                <img
                  loading="lazy"
                  src="/assets/img/whatsapp.webp"
                  className="whatsapp-img"
                  width={25}
                  alt="whatsapp"
                />{' '}
                WHATSAPP
              </Link>
            )}
            {ads.is_call && (
              <Link href={`tel:+91${ads.contact_no}`} className="btntelephone">
                <i className="fa fa-phone"></i> <span className="mobile-view-text">Call Me</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(Index);
